import { lazy } from 'react';

import { PageSuspense } from 'src/components';


const AccountPassportPage = lazy(() => import('../views/update/AccountPassportPage'));

export function AccountPassportPageLazy() {
	return (
		<PageSuspense>
			<AccountPassportPage />
		</PageSuspense>
	);
}
